import React from 'react';
import {Accordion, Card} from "react-bootstrap";

import styles from './ThreeJSCompetition.module.css'

const Question = ({q, a}) =>
  <Accordion>
    <Card style={{background: 'none'}}>
      <Accordion.Toggle as={Card.Body} eventKey="0">
        <h5 className={styles.accordionTitle}>+ {q}</h5>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="0">
        <div className="accordion-content text-start">
          {a}
        </div>
      </Accordion.Collapse>
    </Card>
  </Accordion>

const FAQ = () => (<div id="faq" className="container-help white mt-5">
    <h3 className="bold">FAQs</h3>
    <div className="mt-5">
      <Question
        q="What is three.js?"
        a={<p>
          Three.js is a cross-browser JavaScript library and application programming interface used to create and display animated 3D computer graphics in a web browser using WebGL. The source code is hosted in a repository on GitHub. You can learn more about it <a href="https://medium.com/@pailhead011/what-is-three-js-7a03d84d9489" target="_blank" className="white"><u>here</u></a>.
        </p>}
      />

      <Question q="What is Tiiny Host?" a={<p>
        Sharing your Three.JS project with your audience or clients can be complicated. With Tiiny Host, simply drag & drop your zip file and we'll generate a unique link for you to share your Three.JS design in seconds. Upload it once & share infinitely to audiences all over the world with one simple link!
      </p>} />

      <Question q="How will the competition be judged?" a={<p>
        After 30th June 2022, our three.js judges mentioned above will decide on a 1st, 2nd & 3rd place winner from all the entries submitted.
      </p>} />

      <Question q="Can I update my entry after I submit it?" a={<p>
        Yes, you can up until 30th June 2022. Just <a href="https://tiiny.host/login" className="link-white">login</a> to your account and update your link. Be sure you tweet us with your updated project!
      </p>} />

      <Question q="Do you own my project after it’s entered?" a={<p>
        No. We don’t own any of the content we host and uploading your project does NOT transfer ownership. We do reserve the right to publish it but give you full credit at all stages.
      </p>} />

      <Question q="I’m new to Three.JS. Can I still enter?" a={<p>
        Absolutely! We encourage entries from people with all levels of experience and capability. We want to see your Three.JS project whether you’ve been building it for years or hours.
      </p>} />

      <Question q="Are there any resources you recommend?" a={<p>
        If you’re relatively new to three.js then we strongly recommend checking out this excellent <a href="https://github.com/ektogamat/threejs-andy-bolierplate/pulls" target="_blank" className="link-white"><u>boilerplate</u></a> by Anderson. It’ll provide you with everything you need to get started developing and customising your very own design.
      </p>} />

      <Question q="Can I host my design on my own domain?" a={<p>
        Yes, you can host & share your Three.JS design on your web address and domain. For example, you could upload & share a Zip to myThree.JS.mydesign.com. This would have no effect on your main website. The advantage of this is maintaining your brand whilst sharing your design online. Visitors are also more likely to trust and open files shared with your website name. It’s a short two-step process to configure & connect your web address to Tiiny Host.
      </p>} />

      <Question q="Where are my Three.JS design documents stored?" a={<p>
        We are built upon the industry standard Amazon Web Services (AWS) platform and transmit all data using end-to-end SSL encryption. This means your design is in a reliable and safe location only viewable by users who have the link. If you would like further protection, you can password-protect the link.
      </p>} />

      <Question q="Is Tiiny Host compatible with all devices?" a={<p>
        Yes. Once your Three.JS design is uploaded it can be viewed on any device. Your files are presented through a cross-browser and mobile compatible design viewer. This means that they can be viewed on any device (mobile, desktop or tablet) and in any web browser (Chrome, Firefox, Safari, Edge, Internet Explorer etc.).
      </p>} />
    </div>
</div>);

export default FAQ;
